import React from 'react';

import config from 'config';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import UpsellCarousel from '~/shared/components/UpsellCarousel';
import featureNames from '~/shared/constants/featureFlags';
import { ProductTag } from '~/shared/constants/products';
import { getMembershipExcludedTagIds } from '~/shared/utils/getMembershipExcludedTagIds';
import useHasFeature from '~/shared/utils/useHasFeature';
import useMembershipLevelGroup from '~/shared/utils/useMembershipLevelGroup';
import {
  useProductDetailSelectionState,
  Separator,
} from '~/techstyle-shared/react-components';
import { FormattedMessage } from '~/techstyle-shared/react-intl';
import { useRecommendedProducts } from '~/techstyle-shared/react-products';

import {
  CarouselHeading as BaseCarouselHeading,
  CarouselSection,
} from './shared';

const prefix = config.get('public.brand.psourcePrefix');

const CarouselHeading = styled(BaseCarouselHeading)`
  ${({ theme: { pdpStyles } }) => pdpStyles.upsellCarousel.carouselHeading}
`;

const separatorStyle = css`
  color: ${({ theme }) => theme.colors.separator};
  margin: ${({ theme }) => theme.spacing.sizes.pixels.s}px 0;
`;

function YouWillAlsoLove({ product }) {
  const { enabled: isRetailDiscountingEnabled } = useHasFeature(
    featureNames.RETAILPRICETEST
  );
  const membershipLevelGroup = useMembershipLevelGroup();
  const filterProductTagIds = [
    ProductTag.hidden,
    getMembershipExcludedTagIds(membershipLevelGroup),
  ];

  const { products = [] } = useRecommendedProducts(product.masterProductId, {
    retailDiscounting: isRetailDiscountingEnabled,
    filterProductTagIds,
  });

  const { isPlusSizeSelected } = useProductDetailSelectionState();

  if (!products.length) {
    return null;
  }

  return (
    <CarouselSection data-autotag="pdp-YWAL-section">
      <CarouselHeading data-autotag="pdp-YWAL-section-title">
        <FormattedMessage
          id="site_pdp.you_will_also_love"
          defaultMessage="You Will Also Love"
        />
      </CarouselHeading>
      <Separator thickness={2} separatorStyle={separatorStyle} />
      <UpsellCarousel
        products={products}
        psrc={`${prefix}also_love`}
        isPlusSizeSelected={isPlusSizeSelected}
        data-autotag="pdp-YWAL-products"
        autoPlay={false}
      />
    </CarouselSection>
  );
}

YouWillAlsoLove.propTypes = {
  product: PropTypes.object,
};

export default YouWillAlsoLove;
